/**
 * @generated SignedSource<<a9c9808a72a867d385d77f0bb443584b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommunicationSettingsScreen_CommunicationSettingsFragment$data = {
  readonly id: string;
  readonly sendExpirationNoticeEmails: boolean;
  readonly sendExpirationNoticeNotifications: boolean;
  readonly sendInformRetryEmails: boolean;
  readonly sendInformRetryNotifications: boolean;
  readonly " $fragmentType": "CommunicationSettingsScreen_CommunicationSettingsFragment";
};
export type CommunicationSettingsScreen_CommunicationSettingsFragment$key = {
  readonly " $data"?: CommunicationSettingsScreen_CommunicationSettingsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommunicationSettingsScreen_CommunicationSettingsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommunicationSettingsScreen_CommunicationSettingsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendExpirationNoticeEmails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendExpirationNoticeNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendInformRetryEmails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendInformRetryNotifications",
      "storageKey": null
    }
  ],
  "type": "CommunicationSettings",
  "abstractKey": null
};

(node as any).hash = "640fb6ff3cfcf78e8a248c2ee92b1319";

export default node;
